export default {
  name: "Check",
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  path: {
    d:
      "M14.8 24.33a1 1 0 0 1-.64-.23l-8.8-7.33a1 1 0 0 1-.13-1.41 1 1 0 0 1 1.41-.13l8 6.66L25.21 8.06a1 1 0 0 1 1.4-.19 1 1 0 0 1 .19 1.4L15.6 23.94a1 1 0 0 1-.8.39z",
  },
}
